<template>
  <div class="open-home-container">
    <div class="carousel-container">
      <simple-carousel :items="carouselItems" @action="actionHandler"/>
    </div>
    <div class="product-area">
      <div class="module-title product-area-title">产品服务</div>
      <div class="product-list-nav">
        <div class="product-list-nav-items">
          <div class="nav-item" v-for="(val, key) in productService" :key="key" :class="setCloudClass(key)"
            @click="changeActiveCloud(key)">
            <img :src="val.icon" alt="图标" class="icon">
            <span class="title">{{val.title}}</span>
          </div>
        </div>
      </div>
      <div class="product-list-container-bg">
        <div class="product-list-container">
          <div class="product-list-items">
            <div class="product-list-item"
              v-for="(val, index) in productService[activeCloudClass].items"
              :key="index">
              <div class="product-intro-title">{{val.title}}</div>
              <div class="product-intro-info">{{val.info}}</div>
              <div class="product-intro-button" @click="handleJumpPage(val.url)">
                <span>了解详情</span>
              </div>
            </div>
          </div>
          <!-- <div class="module-link">更多产品服务</div> -->
        </div>
      </div>
    </div>
    <div class="customer-case">
      <div class="module-title">客户案例</div>
      <div class="customer-case-container-bg">
        <div class="customer-case-container">
          <div class="customer-case-item">
            <img class="customer-case-item-img" src="./imgs/customer-case/logo_m_qq.jpg">
            <div class="customer-case-item-content">
              <div class="customer-case-item-title">
                <span class="customer-case-item-name">手机QQ</span>
                <span class="customer-case-item-sort">互联网</span>
              </div>
              <div class="customer-case-item-text">
                手机QQ是移动互联网领航级手机应用，服务超过5.7亿的月活跃用户。手Q中的名片识别功能由优图团队和手Q团队联合打造。在日常社交中，扫描下名片即可方便的保存好友姓名，电话，QQ号等信息。</div>
              <div class="customer-case-item-detail" @click="handleJumpPage('OPEN_COOPERATION', 'NETWORK')">了解详情</div>
            </div>
          </div>
          <div class="customer-case-item">
            <img class="customer-case-item-img" src="./imgs/customer-case/logo_m_webank.jpg">
            <div class="customer-case-item-content">
              <div class="customer-case-item-title">
                <span class="customer-case-item-name">微众银行</span>
                <span class="customer-case-item-sort">金融</span>
              </div>
              <div class="customer-case-item-text">
                微众银行是国内首家互联网银行，微众的远程核身流程应用了优图的人脸检测和人脸核身技术。李克强总理2015年1月4日亲自视察WeBank银行，当场见证了微众银行人脸核身演示。凭借世界顶尖的人脸验证、声纹验证、语音识别等技术，在智能手机上安全、有效的解决实名制远程用户核身验证的难题，属国内首创。。
              </div>
              <div class="customer-case-item-detail" @click="handleJumpPage('OPEN_COOPERATION', 'FINANCE')">了解详情</div>
            </div>
          </div>
          <div class="customer-case-item">
            <img class="customer-case-item-img" src="./imgs/customer-case/logo_m_wysd.jpg">
            <div class="customer-case-item-content">
              <div class="customer-case-item-title">
                <span class="customer-case-item-name">微影时代</span>
                <span class="customer-case-item-sort">其他</span>
              </div>
              <div class="customer-case-item-text">
                腾讯优图助力微影时代建设人脸识别智能闸机，主要用于工作人员人脸验证入场和观众人脸识别入场两种业务场景。其中工作人员人脸验证入场使用1:1人脸对比技术能迅速判断出是否为同一人，观众识别入场使用1:N人脸检索技术迅速判断出该观众是否是购票用户。它能够有效记录用户入场行为，保证演出现场安全，并能防止黄牛囤票、出售假票的情况，在提升验票效率的同时，将验票体验也一同升级。
              </div>
              <div class="customer-case-item-detail" @click="handleJumpPage('OPEN_COOPERATION', 'OTHER')">了解详情</div>
            </div>
          </div>
        </div>
        <!-- <div class="module-link">更多客户案例</div> -->
      </div>
    </div>
    <div class="news-center">
      <div class="module-title">新闻中心</div>
      <div class="news-center-container-bg">
        <div class="news-center-container">
          <div class="news-center-item" v-for="(val, index) in newsCenter" :key="index" @click="handleJumpPage(val.url)">
            <div class="news-center-title">{{val.title}}</div>
            <div class="news-center-date">{{val.date}}</div>
            <img class="news-center-bgImg" src=""/>
            <div class="news-center-detail"></div>
          </div>
        </div>
        <div class="module-link  module-link-news" @click="handleJumpPage('OPEN_NEWSCENTER')">了解更多新闻动态</div>
      </div>
    </div>
  </div>
</template>
<script>
import RouteKey from '@/common/RouteKey';
import SimpleCarousel from '@/components/open/common/SimpleCarousel';
import NewsBroadcast from '@/components/open/common/NewsBroadcast';
import EventEmitter from '@/components/open/common/EventEmitter';
import Constant from '@/components/open/common/Constant';
import config from './config';
import qc from '../../common/plugin/qc';
import ValidateTransferHelper from '@/components/open/common/ValidateTransferHelper';
import * as actionTypes from '@/store/open/action-types';
import ModuleData from './data/ModuleData';
const IS_VALID_LOGIN = 1;
const IS_VERIFYED_MAIL = 1;
const IS_VERIFY_PHONE = 1;
const productService = ModuleData['productService'];
const newsCenter = ModuleData['newsCenter'];

export default {
  name: 'Home',
  components: {
    SimpleCarousel,
    NewsBroadcast
  },
  /*
  mounted() {
    this.honorWidth = 2000 - document.documentElement.clientWidth;
    this.honorLeft = 0;
    window.onresize = () => {   // 屏幕尺寸变化就重新赋值
      this.honorWidth = 2000 - document.documentElement.clientWidth;
      this.honorLeft = 0;
    };
  }, */
  methods: {
    handleJumpPage(url, key) {
      if (url.indexOf('http') !== -1) {
        window.open(url, '_blank');
        return;
      }
      url = RouteKey[url];
      if (key != null) {
        this.$router.transfer(url, {key: key});
        return;
      }
      this.$router.transfer(url);
    },
    actionHandler(item) {
      if (this.$store.state.open.user.isLogin !== true && item.needLogin) {
        EventEmitter.fire(Constant.Events.SHOW_LOGIN);
        return;
      }
      this.$router.transfer(item.actionTransferUrl);
    },
    setCloudClass(key) {
      let obj = {};
      obj[key] = true;
      obj['active'] = (this.activeCloudClass === key);
      return obj;
    },
    setSolutionClass(key) {
      let obj = {};
      obj[key] = true;
      obj['active'] = (this.activesolutionClass === key);
      return obj;
    },
    changeActiveCloud(key) {
      this.activeCloudClass = key;
    },
    changeActiveSolution(key) {
      this.activesolutionClass = key;
    },
    receiveUserInfo(result) {
      if (result.errorcode !== 0) {
        this.$alert(result.msg || '网络异常，请稍后再试');
        return;
      }
      let isVerifyMail = result.is_verify === IS_VERIFYED_MAIL;
      let isVerifyPhone = result.is_phone_verified === IS_VERIFY_PHONE;
      this.$store.dispatch(actionTypes.SAVE_USER_INFO, {
        isLogin: result.is_login === IS_VALID_LOGIN,
        isVerifyMail: isVerifyMail,
        isVerifyPhone: isVerifyPhone,
        qq: result.qq,
        userName: result.user_name,
        openid: result.openid,
        news: result.news,
        token: result.token || ''
      });
      localStorage.setItem('token', result.token);
      if (isVerifyMail && isVerifyPhone) {
        this.$router.transfer(RouteKey.OPEN_APP_DISPLAY);
      } else {
        ValidateTransferHelper.transferNext();
      }
    },
    login() {
      qc.showLogin(this.receiveUserInfo.bind(this));
    }
    /*
    goRight() {
      if (this.honorLeft > -this.honorWidth) {
        this.honorLeft = this.honorLeft - 100;
      }
    },
    goLeft() {
      if (this.honorLeft < 0) {
        this.honorLeft = this.honorLeft + 100;
      }
    } */
  },
  data() {
    return {
      carouselItems: config.carouselItems,
      newsItems: config.news,
      RouteKey,
      productService,
      newsCenter,
      activeCloudClass: 'aiInternet',
      // ourAdvantage,
      // solutionProgram,
      activesolutionClass: 'liveVideo'
      // honorLeft: 0,
      // honorWidth: 0
    };
  }
};
</script>
<style lang="less" scoped>
@import "./css/home.less";
</style>



// WEBPACK FOOTER //
// src/components/open/panels/home/Home.vue